import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { DatePickerModule } from 'primeng/datepicker';
import { InputIconModule } from 'primeng/inputicon';
import { SelectModule } from 'primeng/select';
import { Popover } from 'primeng/popover';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { DrawerModule } from 'primeng/drawer';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { DropdownModule } from 'primeng/dropdown';


interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-tool-bar',
  imports: [IconFieldModule, CommonModule, ButtonModule,
    FormsModule, DatePickerModule, InputIconModule, SelectModule,
    Popover, InputGroup, InputGroupAddonModule, InputTextModule, MenuModule, DrawerModule, CheckboxModule,DropdownModule
  ],
  templateUrl: './tool-bar.component.html',
  styleUrl: './tool-bar.component.scss'
})
export class ToolBarComponent {

  @Input() title: string = '';
  @Input() iconName: string = '';
  @Input() isSearch: boolean = false;
  @Input() isDateFilter: boolean = false;
  @Input() isImport: boolean = false;
  @Input() isExport: boolean = false;
  @Input() isAdd: boolean = false;
  @Input() selectedProducts: any[] = [];
  @Input() isBulkAction: boolean = false;
  @Input() isFilter: boolean = false;
  @Input() isRefresh: boolean = false;
  @Output() handleBulkAction = new EventEmitter<any>();
  @Output() handleAdd = new EventEmitter<any>();
  @Input() bulkActionItems: any[] = [];
  @Input() filterOptions: any[] = [];
  @Input() exportItems: any[] = [];
  @Input() filtersOptions: any[] = [];
  @Input() searchFilters: any[] = []; // From parent (e.g. name/type)
selectedFilter: string = '';
searchText: string = '';

  @Output() bulkUpload = new EventEmitter<any>();
  @Output() search = new EventEmitter<{ value: string; selectedFilterAttribute: string }>();
  @Output() dateFilter = new EventEmitter<any>();
  @Output() handleRefresh = new EventEmitter<any>();
  @Output("ExportData") ExportData: EventEmitter<any> = new EventEmitter();

  @Output() resetDateFilter = new EventEmitter<any>();
  @Output() emitSearch = new EventEmitter<string>();


  cities: City[] | undefined;

  selectedCity: City | undefined;

  showFilterDrawer: boolean = false;
  selectAllChecked: boolean = false;


  rangeDates: Date[] | undefined;


  selectedFilterAttribute = '';

  private searchSubject = new Subject<string>();

  constructor(
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.rangeDates = [new Date(), new Date()];
    this.cities = [
      { name: 'New York', code: 'NY' },
      { name: 'Rome', code: 'RM' },
      { name: 'London', code: 'LDN' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' }
    ];
    if (!this.searchFilters || this.searchFilters.length === 0) {
      this.searchFilters = [
        { label: 'Name', value: 'name' },
        { label: 'Type', value: 'type' }
      ];
    }

    this.searchSubject.pipe(
      debounceTime(1000), // Wait 500ms after the last keystroke
      distinctUntilChanged() // Ignore consecutive duplicate values
    ).subscribe(value => {
      this.search.emit({
        value: this.searchText,
        selectedFilterAttribute: this.selectedFilterAttribute 
      });
    });
  }

  handleSelectedBulkAction(event: any) {
    this.handleBulkAction.emit(event);
  }

  checkedData: any[] = [];

  storeCheckedData() {
    this.checkedData = this.filterOptions.map(group => ({
      label: group.label,
      items: group.items.filter((item: any) => item.checked)
    }));
    console.log(this.checkedData);
  }

  clearFilters() {
    this.filterOptions.forEach(group => {
      group.items.forEach((item: any) => item.checked = false);
    });
  }


  // Toggle individual checkboxes
  toggleSelection(index: number) {
    this.exportItems[index].checked = !this.exportItems[index].checked;
  }

  // Toggle all checkboxes
  toggleSelectAll() {
    // this.selectAllChecked = !this.selectAllChecked;
    console.log('Select All:', this.selectAllChecked);
    this.exportItems.forEach(item => (item.checked = this.selectAllChecked));
  }

  // Save Selected Values
  saveSelection() {
    const selectedValues = this.exportItems
      .filter(item => item.checked)
      .map(item => item);
    console.log('Selected values:', selectedValues);

    if (selectedValues.length == 0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select column' });
      return;
    }
    this.selectAllChecked = false;
    this.ExportData.emit(selectedValues);

  }

  handleAddAction() {
    this.handleAdd.emit();
  }

  handleOpenBulkAdd() {
    this.bulkUpload.emit();
  }

  onSearchChange(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.searchSubject.next(inputValue);
  }

  handleRefreshDateFilter() {
    this.rangeDates = [new Date(), new Date()];
    this.dateFilter.emit({
      startDate: null,
      endDate: null
    });
  }

  onDateChange(event: any) {

    console.log("rangeDates", this.rangeDates);
    let startDate;
    let endDate;

    if(this.rangeDates && this.rangeDates[0] != undefined){
      startDate = this.formatDate(this.rangeDates[0]);
    }

    if(this.rangeDates && this.rangeDates[1] != undefined){
      endDate = this.formatDate(this.rangeDates[1]);
    }
    
    if(startDate && endDate){
      console.log('Start Date:', startDate);
      console.log('End Date:', endDate);
      this.dateFilter.emit({
        startDate,
        endDate
      });
    }

  }
  formatDate = (dateString: any): string => {
    console.log('Date:', dateString);
    const date = new Date(dateString);
    const yy = date.getFullYear().toString(); // Get last 2 digits of year
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
    const dd = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    return `${yy}-${mm}-${dd}`;
  };


  refreshData() {
    this.handleRefresh.emit();
  }

  handleResetDateFilter() {
    this.resetDateFilter.emit();
    this.rangeDates = [new Date(), new Date()];
  }


}
